import { createSelector } from '@ngrx/store';
import {
	IIncidentState,
	IncidentEntitySelector,
} from '@app/pages/cmms/components/incident/state/incidents.reducer';
import { AuUtilsFunctions } from '@app/shared';

import {
	defaultPageSize,
	paginationQueryVariables,
} from '@app/pages/cmms/configs/pagination-query-variables';

export const selectIncidentState = state => state.cmms.incidentState;

export const incidentsIsLoading = createSelector(
	selectIncidentState,
	(state: IIncidentState) => state.incidentsIsLoading
);

export const incidentEntities = createSelector(
	selectIncidentState,
	IncidentEntitySelector.selectEntities
);

export const allIncidents = createSelector(
	selectIncidentState,
	(state: IIncidentState) => {
		return {
			incidents: IncidentEntitySelector.selectAll(state),
			incidentsPagination: state.incidentPagination,
		};
	}
);

export const incidentAuPagination = createSelector(
	selectIncidentState,
	(state: IIncidentState) => state.incidentAuPagination
);

export const incidentPageSize = createSelector(
	selectIncidentState,
	(state: IIncidentState) =>
		state.incidentAuPagination?.first ??
		state.incidentAuPagination?.last ??
		defaultPageSize
);

export const incidentsQueryVariables = createSelector(
	selectIncidentState,
	(state: IIncidentState) => state.incidentsQueryVariables
);

export const incidentsQueryVariablesWithoutPagination = createSelector(
	selectIncidentState,
	(state: IIncidentState) => {
		if (state.incidentsQueryVariables) {
			return AuUtilsFunctions.excludeObjectKeys(
				state.incidentsQueryVariables,
				paginationQueryVariables
			);
		}
	}
);

export const incidentsTableColumnKeys = createSelector(
	selectIncidentState,
	(state: IIncidentState) => {
		return (state.tableColumnsConfig ?? []).map(column => column.key);
	}
);

export const incidentsTableExportUrlQuery = createSelector(
	selectIncidentState,
	(state: IIncidentState) => state.exportUrlQuery
);

export const isIncidentsTableExportable = createSelector(
	selectIncidentState,
	(state: IIncidentState) => state.isExportable
);

export const incidentsExportTableData = createSelector({
	isExportable: isIncidentsTableExportable,
	queryVariables: incidentsQueryVariablesWithoutPagination,
	columnKeys: incidentsTableColumnKeys,
	exportUrlQuery: incidentsTableExportUrlQuery,
});

export const incidentsTotal = createSelector(
	selectIncidentState,
	IncidentEntitySelector.selectTotal
);

export const editingIncident = createSelector(
	selectIncidentState,
	(state: IIncidentState) => state.incidentEdit
);

export const incidentData = createSelector(
	selectIncidentState,
	(state: IIncidentState) => state.incidentData
);

export const incidentSelectedCalendarDate = createSelector(
	selectIncidentState,
	(state: IIncidentState) => state.selectedCalendarDate
);
